export default __webpack_public_path__ + "static/media/VISUAL_AND_PERFORMING_ARTS_DANCE.f9a0939f.svg";